export default __webpack_public_path__ + "static/media/oshe.0629861f.png";